import { getUserOrganizationResponse } from '#pplx/frontend/user-info/orgInfoQueries.js';
export const getUserOrganizationOrThrow = async (params) => (await getUserOrganizationResponse(params));
export const getUserOrganization = getUserOrganizationOrThrow;
//# sourceMappingURL=getUserOrganization.js.map